'use strict'

import Application from './Classes/Application'

document.addEventListener('DOMContentLoaded', () => {
  (() => new Application())()
})
